<template>
  <div class="navbar">
    <a class="leftNav" href="/">
      <div class="logoTopFixed" style="color: #00a2ff">
        <img src="@/assets/logo.png" alt="" @click="goHome" />
      </div>
    </a>

    <div class="right-menu">
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
          {{ name }}
          <i
            class="el-icon-caret-bottom"
            style="vertical-align: middle; margin-top: -6.8px"
          />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <!-- <a @click="getManagerInfo"> -->
          <!-- <el-dropdown-item divided @click.native="getManagerInfo"
            >个人信息</el-dropdown-item
          > -->
          <!-- </a> -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { editManagerInfo, updateManagerInfo } from "@/axios/common";
export default {
  data() {
    return {
      userInfoViable: false,
      form: {
        re_password: null,
        password: null,
      },
      flag: true,
      pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/,
      tip: {
        color: "red",
      },
    };
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device", "name"]),
  },
  mounted() {
    console.log(this.device, 9090909);
    if (store.getters.status == 1) {
      this.flag = false;
      // this.$message.warning("密码强度过低，请修改密码");
      this.getManagerInfo();
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push(`/login?redirect=Dashboard`);
    },
    async getManagerInfo() {
      let res = await editManagerInfo();
      this.form = res.data;
      // this.form.password = res.data.PASSWORD_;
      // this.form.re_password = res.data.PASSWORD_;
      this.userInfoViable = true;
    },
    goHome() {
      console.log(1122);
    },
    async submit() {
      if (
        this.form.password != undefined &&
        (this.form.password.length < 6 || this.form.re_password.length < 6)
      ) {
        this.$message.error("密码长度需大于6位");
        return;
      }
      if (
        this.form.password != "" &&
        this.form.password !== this.form.re_password
      ) {
        this.$message.error("密码不同");
        return;
      }
      if (this.pattern.test(this.form.re_password) == false) {
        this.$message.warning("密码强度过低,含数字字母组合，不少于6位");
        return;
      }
      let res = await updateManagerInfo(this.form);
      if (
        this.form.re_password != undefined &&
        this.form.re_password.length > 0
      ) {
        this.$message.success("请重新登录");
        this.logout();
      } else {
        this.$message.success(res.message);
        this.userInfoViable = false;
      }
    },
    inputOn(e) {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  justify-content: space-between;

  .leftNav {
    // width: 400px;
    text-align: left;
    display: flex;

    .logoTopFixed {
      /* span{
              font-size: 24px;
              line-height: 45px;
              background-image:linear-gradient(to right,#0090FF,#39C9FF);
              -webkit-background-clip:text;
              -webkit-text-fill-color:transparent;
              padding-top:10px;
              } */
      width: 290px;

      img {
        display: block;
        height: 32px; // height:30px
        // width:232px;  // width:230px
        margin-top: 10px; // 原margin-top:14px
        margin-left: 10px;
      }
    }

    .leftMenu {
      cursor: pointer;
    }

    .rightMenu {
      flex: 1;

      .el-breadcrumb {
        line-height: 50px;
        margin-left: 10px;
      }
    }
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 15px;
      // height: 100%;
      font-size: 14px;
      color: #00a2ff;

      // vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }

      &.router {
        background: #fff;
        /* border-radius: 5px; */
        color: #00a2ff;
        line-height: 40px;
        cursor: pointer;

        &.diff {
          margin-left: 0pc;
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        // margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
